import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTaskAssignmentsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.TaskAssignmentDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.TaskAssignmentDocumentSortInput> | Types.TaskAssignmentDocumentSortInput>;
}>;


export type GetTaskAssignmentsQuery = { __typename?: 'Query', taskAssignments?: { __typename?: 'TaskAssignmentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TaskAssignmentDocument', id: string, taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, dueDate?: Types.TDateISO | null, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, activeTimerStartTime?: Types.TDateISO | null, activeTimerCreatedBy?: string | null, totalDurationSeconds: number, totalLaborUnits: number, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, plannedMove?: { __typename?: 'PlannedProductionJobMove', fromLocationName?: string | null, toLocationName: string, moveDate: Types.TDateISO } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTaskAssignmentQueryVariables = Types.Exact<{
  taskAssignmentId: Types.Scalars['String']['input'];
}>;


export type GetTaskAssignmentQuery = { __typename?: 'Query', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, timeEntries: Array<{ __typename?: 'TimeEntryData', createdBy: string, duration: unknown }>, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null };

export type GetMyTaskAssignmentsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.TaskAssignmentDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.TaskAssignmentDocumentSortInput> | Types.TaskAssignmentDocumentSortInput>;
}>;


export type GetMyTaskAssignmentsQuery = { __typename?: 'Query', taskAssignments?: { __typename?: 'TaskAssignmentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TaskAssignmentDocument', id: string, taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, dueDate?: Types.TDateISO | null, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, activeTimerStartTime?: Types.TDateISO | null, activeTimerCreatedBy?: string | null, totalDurationSeconds: number, totalLaborUnits: number, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, plannedMove?: { __typename?: 'PlannedProductionJobMove', fromLocationName?: string | null, toLocationName: string, moveDate: Types.TDateISO } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type TaskAssignmentSummaryFragment = { __typename?: 'TaskAssignmentDocument', id: string, taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, dueDate?: Types.TDateISO | null, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, activeTimerStartTime?: Types.TDateISO | null, activeTimerCreatedBy?: string | null, totalDurationSeconds: number, totalLaborUnits: number, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, plannedMove?: { __typename?: 'PlannedProductionJobMove', fromLocationName?: string | null, toLocationName: string, moveDate: Types.TDateISO } | null };

export type TaskPlannedMoveFragment = { __typename?: 'PlannedProductionJobMove', fromLocationName?: string | null, toLocationName: string, moveDate: Types.TDateISO };

export type GetTaskPlannedMoveQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.TaskAssignmentDocumentFilterInput>;
}>;


export type GetTaskPlannedMoveQuery = { __typename?: 'Query', taskAssignments?: { __typename?: 'TaskAssignmentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TaskAssignmentDocument', taskAssignmentId: string, plannedMove?: { __typename?: 'PlannedProductionJobMove', fromLocationName?: string | null, toLocationName: string, moveDate: Types.TDateISO } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type TaskAssignmentDetailFragment = { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> };

export const TaskPlannedMoveFragmentDoc = new TypedDocumentString(`
    fragment TaskPlannedMove on PlannedProductionJobMove {
  fromLocationName
  toLocationName
  moveDate
}
    `, {"fragmentName":"TaskPlannedMove"});
export const TaskAssignmentSummaryFragmentDoc = new TypedDocumentString(`
    fragment TaskAssignmentSummary on TaskAssignmentDocument {
  id
  taskAssignmentId
  taskEventName
  assignedTo
  status
  dueDate
  sourceLevel
  productionJobId
  productionJobNumber
  activeTimerStartTime
  activeTimerCreatedBy
  totalDurationSeconds
  totalLaborUnits
  startedAt
  startedBy
  completedAt
  completedBy
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
  plannedMove {
    ...TaskPlannedMove
  }
}
    fragment TaskPlannedMove on PlannedProductionJobMove {
  fromLocationName
  toLocationName
  moveDate
}`, {"fragmentName":"TaskAssignmentSummary"});
export const TaskAssignmentDetailFragmentDoc = new TypedDocumentString(`
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}
    `, {"fragmentName":"TaskAssignmentDetail"});
export const GetTaskAssignmentsDocument = new TypedDocumentString(`
    query GetTaskAssignments($first: Int, $after: String, $last: Int, $before: String, $where: TaskAssignmentDocumentFilterInput, $order: [TaskAssignmentDocumentSortInput!]) {
  taskAssignments(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...TaskAssignmentSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment TaskAssignmentSummary on TaskAssignmentDocument {
  id
  taskAssignmentId
  taskEventName
  assignedTo
  status
  dueDate
  sourceLevel
  productionJobId
  productionJobNumber
  activeTimerStartTime
  activeTimerCreatedBy
  totalDurationSeconds
  totalLaborUnits
  startedAt
  startedBy
  completedAt
  completedBy
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
  plannedMove {
    ...TaskPlannedMove
  }
}
fragment TaskPlannedMove on PlannedProductionJobMove {
  fromLocationName
  toLocationName
  moveDate
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetTaskAssignmentDocument = new TypedDocumentString(`
    query GetTaskAssignment($taskAssignmentId: String!) {
  taskAssignment(taskAssignmentId: $taskAssignmentId) {
    ...TaskAssignmentDetail
    timeEntries {
      createdBy
      duration
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const GetMyTaskAssignmentsDocument = new TypedDocumentString(`
    query GetMyTaskAssignments($first: Int, $after: String, $where: TaskAssignmentDocumentFilterInput, $order: [TaskAssignmentDocumentSortInput!]) {
  taskAssignments(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...TaskAssignmentSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment TaskAssignmentSummary on TaskAssignmentDocument {
  id
  taskAssignmentId
  taskEventName
  assignedTo
  status
  dueDate
  sourceLevel
  productionJobId
  productionJobNumber
  activeTimerStartTime
  activeTimerCreatedBy
  totalDurationSeconds
  totalLaborUnits
  startedAt
  startedBy
  completedAt
  completedBy
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
  plannedMove {
    ...TaskPlannedMove
  }
}
fragment TaskPlannedMove on PlannedProductionJobMove {
  fromLocationName
  toLocationName
  moveDate
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetTaskPlannedMoveDocument = new TypedDocumentString(`
    query GetTaskPlannedMove($first: Int, $where: TaskAssignmentDocumentFilterInput) {
  taskAssignments(first: $first, where: $where) {
    nodes {
      taskAssignmentId
      plannedMove {
        ...TaskPlannedMove
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment TaskPlannedMove on PlannedProductionJobMove {
  fromLocationName
  toLocationName
  moveDate
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTaskAssignments: build.query<GetTaskAssignmentsQuery, GetTaskAssignmentsQueryVariables | void>({
      query: (variables) => ({ document: GetTaskAssignmentsDocument, variables })
    }),
    GetTaskAssignment: build.query<GetTaskAssignmentQuery, GetTaskAssignmentQueryVariables>({
      query: (variables) => ({ document: GetTaskAssignmentDocument, variables })
    }),
    GetMyTaskAssignments: build.query<GetMyTaskAssignmentsQuery, GetMyTaskAssignmentsQueryVariables | void>({
      query: (variables) => ({ document: GetMyTaskAssignmentsDocument, variables })
    }),
    GetTaskPlannedMove: build.query<GetTaskPlannedMoveQuery, GetTaskPlannedMoveQueryVariables | void>({
      query: (variables) => ({ document: GetTaskPlannedMoveDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTaskAssignmentsQuery, useLazyGetTaskAssignmentsQuery, useGetTaskAssignmentQuery, useLazyGetTaskAssignmentQuery, useGetMyTaskAssignmentsQuery, useLazyGetMyTaskAssignmentsQuery, useGetTaskPlannedMoveQuery, useLazyGetTaskPlannedMoveQuery } = injectedRtkApi;
